import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import { TabBar, Tab, TabIcon, TabIconText, TabBarScroller } from 'rmwc/Tabs'
import ReactGA from 'react-ga';
import ActivityLeaderboard from './ActivityLeaderboard';
import UserRewardHistory from './UserRewardHistory';

class LeaderboardMainPage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            activeTabIndex: 0,
            selectedTabIndex: 0
    	}
    }

    componentDidMount() {
    }

    onTabChange = evt => {
        this.setState({'activeTabIndex': evt.target.value, 'selectedTabIndex': evt.target.value})
    };

    render() {
    	let mainPageContent

    	mainPageContent = (
    		<div>
        		<Grid>
        			<GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">Chalk Points - Leaderboard & Activities</Typography>
                        </Card>
        			</GridCell>
        		</Grid>
                <div className="mdc-layout-grid__inner"> 
                    <div className="mdc-layout-grid__cell--span-12">
                        <TabBarScroller>
                            <div>
                                <TabBar
                                    activeTabIndex={this.state.activeTabIndex}
                                    onChange={this.onTabChange}>
                                    <Tab>Leaderboard</Tab>
                                    <Tab>Activity Details</Tab>
                                </TabBar>
                            </div>
                        </TabBarScroller>
                        {this.state.activeTabIndex == 0 && <ActivityLeaderboard isAdmin = {false}/>}
                        {this.state.activeTabIndex == 1 && <UserRewardHistory />}
                    </div>
                </div>
            </div>
    	)

    	return (
    		<div>
    			{mainPageContent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardMainPage);


// WEBPACK FOOTER //
// ./src/views/rewards_user/LeaderboardMainPage.jsx